import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Api from "../../api/axios";
import { ICON_BIN } from "../../utils/icons";

const DeleteModal = ({ children, getDataFn, payload, url, name, dataName }) => {

    const [deleting, setdeleting] = useState(false);

    const [showremove, setShowremove] = useState(false);
    const handleCloseremove = () => setShowremove(false);
    const handleShowremove = () => setShowremove(true);

    //   Delete Function
    //   Delete Function

    function submitFn(e) {
        e.preventDefault();
        setdeleting(true);
        const data = {
            ...payload
        };

        Api.post(`${ url }`, data)
            .then((res) => {
                if (res.success === false) {
                    toast.warn(res.message);
                    setdeleting(false);
                    getDataFn();
                } else {
                    setdeleting(false);
                    toast.success(res.message);
                    getDataFn();
                    handleCloseremove();
                }
            })
            .catch((error) => {
                setdeleting(false);
            });
    }

    //   Delete Function
    //   Delete Function

    return (
        <>

            <span onClick={e => handleShowremove()}>
                {children}
            </span>


            <Modal
                show={showremove}
                onHide={handleCloseremove}
                size="sm"
            >
                <div className="modal-header d-flex justify-content-center">
                    <p className="heading m-0 fw-bolder">Confirm</p>
                </div>
                <Modal.Body>
                    <div className="text-center">

                        <i className="fa-4x text-danger">
                            {ICON_BIN}
                        </i>
                        <p className="">
                            Are you sure you want to delete <span> <b> {name} </b> </span> from the list of {dataName} ?
                        </p>

                    </div>
                </Modal.Body>
                <div className="modal-footer justify-content-center">
                    {deleting ?
                        <a type="button" className="btn btn-outline-danger waves-effect"
                        >Deleting...</a>
                        :
                        <>
                            <a type="button" className="btn btn-outline-danger waves-effect"
                                onClick={e => handleCloseremove()}
                            >No</a>
                            <a href="" className="btn btn-danger  waves-effect "
                                onClick={e => submitFn(e)}
                            >Yes</a>
                        </>
                    }
                </div>
            </Modal>
        </>
    );
};

export default DeleteModal;